// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"51af1195","239":"41a9a8ec","401":"e8e28335","426":"5e0d7acc","458":"e0723a12","519":"971f9aef","667":"7f846b8f"}[chunkId] + ".chunk.js";
};